import { getLocale } from '@/i18n/locale';
import { ELocale } from '@/i18n/localeEnum';
import { ENV } from '@/ots-constants';

export const fallback = { fileName: 'prebid' };

// Deduped from the original layout — TS 5 forbids duplicate keys in object
// literals. JS-runtime behaviour kept last-wins, so:
//   FR_FR → 'prebid_fr'   (was overridden from 'prebid_green' lower down)
//   NL_NL → 'prebid_green' (dupe of identical value)
//   DE_DE → 'prebid_dach'  (dupe of identical value)
const prebidConfig: Record<ELocale, { fileName: string }> = {
  [ELocale.NL_NL]: { fileName: 'prebid_green' },
  [ELocale.FR_FR]: { fileName: 'prebid_fr' },
  [ELocale.CS_CZ]: { fileName: 'prebid_czech' },
  [ELocale.DA_DK]: { fileName: 'prebid_green' },
  [ELocale.DE_DE]: { fileName: 'prebid_dach' },
  [ELocale.ES_ES]: { fileName: 'prebid_green' },
  [ELocale.IT_IT]: { fileName: 'prebid_italy' },
  [ELocale.NN_NO]: { fileName: 'prebid_norway' },
  [ELocale.PL_PL]: { fileName: 'prebid_poland' },
  [ELocale.SK_SK]: { fileName: 'prebid_green' },
  [ELocale.SV_SE]: { fileName: 'prebid_slovakia' },
  [ELocale.EN_GB]: { fileName: 'prebid_uk' },
  [ELocale.EN_US]: { fileName: 'prebid_us' },
};

export const getPrebid = () => {
  const locale = getLocale() as ELocale;
  const { fileName } = prebidConfig[locale] || fallback;
  const domainFallback = (ENV === 'production') ? 'https://prebid.onthesnow.com' : 'https://prebid-test.onthesnow.com';
  const domain = process.env.NEXT_PUBLIC_PREBID_DOMAIN || domainFallback;
  return `${domain}/${fileName}.js?${process.env.VERSION}`;
};
